import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html'
})
export class LoaderComponent implements OnInit {
    @Input()
    loader: Boolean; // Defeines the requirment of the loader

    constructor() { }

    ngOnInit() {
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/shared/components/loader/loader.component.ts